export class Token {
  id = null;
  name = null;
  icon = null;
  amount = null;

  constructor(id, name, icon, amount) {
    this.id = id;
    this.name = name;
    this.icon = icon;
    this.amount = amount;
  }
}
